import type React from 'react';
import Results from './Results/Results';
import Contact from './Contact/Contact';
import type { BankDetail, Category, CustomerService } from '../../types';
import Section from '../../../../general/Section/Section';

interface ContainerProps {
  bankDetail: BankDetail;
  categories: Category[];
  contactInfo: CustomerService;
  faqUri: string;
}

const Container: React.FC<ContainerProps> = ({
  bankDetail,
  categories,
  contactInfo,
  faqUri,
}) => (
  <Section isSm>
    <div className="is-grid has-col-3">
      <Results
        categories={categories}
        faqUri={faqUri}
        bankDetail={bankDetail}
        contactInfo={contactInfo}
      />
      <Contact contactInfo={contactInfo} />
    </div>
  </Section>
);

export default Container;
